import {apiGet, apiPost} from "../../shared/api/client";

const cleanParams = (values = {}) => Object.fromEntries(
    Object.entries(values).filter(([, value]) => value !== "" && value !== null && value !== undefined),
);

const parseCommissionPercent = (value) => {
    const number = Number(String(value ?? "").trim().replace(",", "."));
    return Number.isFinite(number) ? number : 0;
};

const trimProfile = (profile, {includePassword = false} = {}) => ({
    username: String(profile.username || "").trim(),
    ...(includePassword ? {password: String(profile.password || "").trim()} : {}),
    phone_number: String(profile.phone_number || "").trim(),
    email: String(profile.email || "").trim(),
    name: String(profile.name || "").trim(),
    note: String(profile.note || "").trim(),
    commission_percent: parseCommissionPercent(profile.commission_percent),
});

const countryConfig = (countryId) => ({params: cleanParams({country_id: countryId})});

export const DEFAULT_DEPLOYERS_PAGE_SIZE = 20;

export const loadDeployers = async ({
    countryId,
    page = 1,
    search,
    pageSize = DEFAULT_DEPLOYERS_PAGE_SIZE,
    staffRole,
} = {}) =>
    apiGet("/api/v2/admin/deployers", {
        params: cleanParams({
            country_id: countryId,
            page,
            search: String(search || "").trim() || undefined,
            // Дефолт бэкенда — 20: не шлем параметр, чтобы запрос совпадал с прежними клиентами.
            page_size: Number(pageSize) === DEFAULT_DEPLOYERS_PAGE_SIZE ? undefined : Number(pageSize),
            // Внедренец — дефолт ручки. Агентов запрашиваем явно, старые клиенты параметр не шлют.
            staff_role: staffRole && staffRole !== "Внедренец" ? staffRole : undefined,
        }),
    });

export const loadDeployer = async ({deployerId, countryId}) =>
    apiGet(`/api/v2/admin/deployers/${deployerId}`, countryConfig(countryId));

export const createDeployer = async ({countryId, staffRole, ...profile}) =>
    apiPost("/api/v2/admin/deployers", {
        ...trimProfile(profile, {includePassword: true}),
        ...(staffRole && staffRole !== "Внедренец" ? {staff_role: staffRole} : {}),
        ...(countryId === undefined || countryId === null || countryId === ""
            ? {}
            : {country_id: Number(countryId)}),
    });

export const editDeployer = async ({deployerId, countryId, ...profile}) =>
    apiPost(
        `/api/v2/admin/deployers/${deployerId}/edit`,
        trimProfile(profile),
        countryConfig(countryId),
    );

export const toggleDeployerActive = async ({deployerId, countryId}) =>
    apiPost(`/api/v2/admin/deployers/${deployerId}/stop`, undefined, countryConfig(countryId));

export const rotateDeployerCredential = async ({deployerId, countryId, password}) =>
    apiPost(
        `/api/v2/admin/deployers/${deployerId}/credentials/rotate`,
        {password: String(password || "").trim()},
        countryConfig(countryId),
    );

export const loadDeployerLicenseRequests = async ({status = "pending"} = {}) =>
    apiGet("/api/v2/admin/deployer-license-requests", {params: cleanParams({status})});

export const approveDeployerLicenseRequest = async (requestId) =>
    apiPost(`/api/v2/admin/deployer-license-requests/${requestId}/approve`);

export const rejectDeployerLicenseRequest = async (requestId) =>
    apiPost(`/api/v2/admin/deployer-license-requests/${requestId}/reject`);

export const grantDeployerLicenses = async ({deployerId, quantity}) =>
    apiPost(`/api/v2/admin/deployers/${deployerId}/licenses`, {quantity});
